<div class="tab-container">
    <div class="tab">
        <div *ngIf="tituloHeader !== ''" class="content-title-tab">
            <label>{{tituloHeader}}</label>
        </div>
        <button *ngFor="let tab of tabs" [class.active]="activeTab === tab.name" (click)="setActiveTab(tab.name)">
            {{ tab.label }}
        </button>
        <div class="content-icon-header">
            <div *ngFor="let itemIcon of accionIconLeft; let i = index">
                <app-icon-action [icon]="itemIcon.icon " [messageTooltip]="itemIcon.titleToltip" [isDropdown]="itemIcon.dropdown?.isDropDown ?? false"
                    [opciones]="itemIcon.dropdown?.opciones ?? []" [name]="itemIcon.name"
                    [positionTooltip]="itemIcon.positionToltip" (clickAction)="clickPress($event)"></app-icon-action>
            </div>
            <div class="separador-icon-action" *ngIf="separador">
                <div class="line">
                </div>
            </div>
            <div *ngFor="let itemIcon of accionIconRight; let i = index">
                <app-icon-action [icon]="itemIcon.icon " [messageTooltip]="itemIcon.titleToltip" [isDropdown]="itemIcon.dropdown?.isDropDown ?? false"
                    [opciones]="itemIcon.dropdown?.opciones ?? []" [name]="itemIcon.name"
                    [positionTooltip]="itemIcon.positionToltip" (clickAction)="clickPress($event)"></app-icon-action>
            </div>
        </div>
    </div>
    <div class="tab-content" *ngIf="tabTemplates[activeTab]">
        <ng-container *ngTemplateOutlet="tabTemplates[activeTab]"></ng-container>
    </div>

</div>

<!--
<div class="tab-container">
    <div class="tab">
        <button *ngFor="let tab of tabsConfig.tabs" [class.active]="activeTab === tab.name" (click)="setActiveTab(tab.name)">
            {{ tab.label }}
        </button>
    </div>

    <div class="tab-content" *ngIf="tabsConfig.tabTemplates[activeTab]">
        {{tabsConfig.tabTemplates[activeTab]}}
        <ng-container *ngTemplateOutlet="tabsConfig.tabTemplates[activeTab]"></ng-container>
    </div>
</div>-->